import { render } from "./errorHandlingPopup.vue?vue&type=template&id=b2fb665c&scoped=true"
import script from "./errorHandlingPopup.vue?vue&type=script&lang=js"
export * from "./errorHandlingPopup.vue?vue&type=script&lang=js"

import "./errorHandlingPopup.vue?vue&type=style&index=0&id=b2fb665c&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fb665c"]])

export default __exports__